export default __webpack_public_path__ + "static/Leaf12-e865ac655bb1d9cc06fd643b64c35867.png";